import React, { useEffect } from "react";
import "./Why_Choose.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import { getWhy_Choose_Us } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";

const Why_Choose = () => {
  const data = [
    {
      img: "/assets/images/home/why_choose/img1.png",
      title: "Sleep Technology",
      descn:
        "Advanced materials designed to adapt to your body and sleep position",
    },
    {
      img: "/assets/images/home/why_choose/img2.png",
      title: "Breathable Comfort",
      descn: "Temperature-regulating fabrics keep you cool all night long",
    },
    {
      img: "/assets/images/home/why_choose/img3.png",
      title: "Premium Materials",
      descn: "Certified organic & hypoallergenic materials for healthy sleep",
    },
    {
      img: "/assets/images/home/why_choose/img4.png",
      title: "10-Year Warranty",
      descn: "We stand behind our products with industry-leading coverage",
    },
  ];

  const whychooseus = useSelector((state) => state?.home?.addWhyChooseUs);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getWhy_Choose_Us());
  }, []);

  //  console.log(whychooseus,"whychooseus1111111111111111111111111")

  return (
    <section className="Why_Choose">
      <div className="container">
        <Common_Title title={"Why Choose Us?"} />

        <div className="inner_div">
          <div className="row justify-content-center">
            {whychooseus?.map((item) => {
              return (
                <div className="col-xl-3 col-lg-4 col-sm-6 mb-4">
                  <div className="blue_card">
                    <div className="img_holder">
                      <img
                        src={process.env.REACT_APP_IMG_URL + item?.image}
                        className="inner_img"
                      />
                    </div>
                    <div className="text_div">
                      <p className="title_text">{item?.name}</p>
                      <p className="descn_text">{item?.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
